import { Domain } from 'DVWebNodeUtils'

export const isRetail = (domain: Domain) => domain === 'Retail'

export const getEpisodeListPresentationScheme = (domain: Domain) => (
    isRetail(domain) ? 'retail-web-episode-list' : 'global-web-episode-list'
)